<template>
  <v-select
    v-model="filter.group"
    :items="valores || people"
    filled
    chips
    color="blue-grey lighten-2"
    label="Select"
    item-text="name"
    item-value="name"
    :return-object="true"
    multiple
  >
    <template slot="selection" slot-scope="data">
      <v-chip close class="chip--select-multi" @input="remove(data.item)">
        {{ data.item.name }}
      </v-chip>
    </template>
    <template slot="item" slot-scope="data">
      <div
        v-if="data.item.value === 'group'"
        class="title"
        @click="selectGroup(data.item)"
      >
        <v-list-item-title v-html="data.item.name"></v-list-item-title>
      </div>
      <v-list-item-content v-else>
        <v-list-item-title v-html="data.item.name"></v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "Loader",
  props: {
    valores: { type: Array, default: [] },
    filter: { type: Object, default: () => ({ group: [] }) },
  },
  data: () => ({
    peopleSelected: [],
    people: [
      { name: "Sandra Adams" },
      { name: "Ali Connors" },
      { name: "Trevor Hansen" },
      { name: "Tucker Smith" },
      { divider: true },
      { header: "Group 2" },
      { name: "Britta Holt", group: "Group 2" },
      { name: "Jane Smith ", group: "Group 2" },
      { name: "John Smith", group: "Group 2" },
      { name: "Sandra Williams", group: "Group 2" },
    ],
    groupsSelected: [],
  }),
  methods: {
    selectGroup(event) {
      this.$nextTick(() => {
        if (this.groupsSelected.some((item) => item === event)) {
          this.filter.group = this.filter.group.filter((item) =>
            event.sons.some((val) => val !== item.value)
          );

          this.groupsSelected = this.groupsSelected.filter(
            (item) => item.value !== event.value
          );
        } else {
          this.filter.group = this.valores.filter((item) =>
            event.sons.some((val) => val === item.value)
          );

          this.groupsSelected.push(event);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
}
</style>
